import { useRouteError } from "react-router-dom";

import { LinkUnavailable } from "./LinkUnavailable";
import { isEntityMissingError } from "./linkUnavailable.helpers";
import RootError from "./RootError";

/** What a route that loads one entity by id shows for its error: gone entities get the friendly state. */
export const EntityMissingError = ({ error }: { error: unknown }) =>
  isEntityMissingError(error) ? <LinkUnavailable /> : <RootError />;

/** Error boundary for a route that loads one entity by id. */
export const EntityMissingErrorBoundary = () => <EntityMissingError error={useRouteError()} />;
